import { AccountSearchController } from "@dealer-center/ddc-pages-account-search-react";
import { PagesAbout } from "@dealer-center/ddc-pages-about";
import { route as vindecodeRoute } from "@dealer-center/ddc-pages-vin-decode-react";
import { dealerRoutes } from "./DealerRoutes";
import type { RouteObject } from "react-router-dom";
import { route as dealerCodeRoute } from "@dealer-center/ddc-pages-dealer-codes-react";
import { PagesInventoryConfigUi } from "@dealer-center/ddc-pages-inventory-config-react";
import { PagesTedsSandboxPageUi } from "@dealer-center/ddc-pages-teds-sandbox-page-react";
import { PagesUserSearchUi } from "@dealer-center/ddc-pages-user-search-react";
import { PagesImportExport } from "@dealer-center/core-pages-import-export";
import { PagesInventoryArchiverUi } from "@dealer-center/ddc-pages-inventory-archiver-react";
import type { environments } from "@dealer-center/core-enviroment";
import { PagesEmployeeListUi } from "@dealer-center/ddc-pages-employee-list-react";
import { PagesPermissionsManagerUi } from "@dealer-center/ddc-pages-permissions-manager-react";
import { PagesAccountHierarchyUi } from "@dealer-center/ddc-pages-account-hierarchy-react";
import { PagesAccountSwitcherUiUiRoutes } from "@dealer-center/ddc-pages-account-switcher-ui-react";
import { DdcPagesExperimentEnablement } from "@dealer-center/ddc-pages-experiment-enablement";
import { PagesControlcenterUiRoutes } from "@dealer-center/ddc-pages-controlcenter-react";
import { PagesUserPermissionsManagerUiRoutes } from "@dealer-center/ddc-pages-user-permissions-manager-react";
import { PagesFranchiseManagementUiRoutes } from "@dealer-center/ddc-pages-franchise-management-react";
import { gvmRoutes } from "./GvmRoutes";

import { PagesAltTextManagerUiRoutes } from "@dealer-center/ddc-pages-alt-text-manager-react";

export const internalUserRoutes = (enviroment: environments): RouteObject[] => [
  {
    index: true,
    element: <AccountSearchController />
  },
  ...vindecodeRoute,
  dealerCodeRoute,
  {
    path: "about",
    element: <PagesAbout />
  },
  {
    path: "experiment",
    element: <DdcPagesExperimentEnablement />
  },
  {
    path: "import-export",
    element: <PagesImportExport />
  },
  {
    path: "account-search/:tab?",
    element: <AccountSearchController />
  },
  { path: "inventoryArchiver", element: <PagesInventoryArchiverUi /> },
  { path: "inventoryConfig", element: <PagesInventoryConfigUi /> },
  { path: "tedsSandboxPage", element: <PagesTedsSandboxPageUi /> },
  { path: "userSearch", element: <PagesUserSearchUi /> },
  gvmRoutes(enviroment),
  { path: "employeeList", element: <PagesEmployeeListUi /> },
  { path: "permissionsManager", element: <PagesPermissionsManagerUi /> },
  { path: "accountHierarchy", element: <PagesAccountHierarchyUi /> },
  ...PagesAccountSwitcherUiUiRoutes,
  ...PagesControlcenterUiRoutes,
  ...PagesUserPermissionsManagerUiRoutes,
  ...PagesFranchiseManagementUiRoutes,
  ...PagesAltTextManagerUiRoutes,
  // placeholder do not remove
  {
    path: "example",
    element: <div>This is an example page for the root</div>
  },
  dealerRoutes(enviroment),
  {
    path: "*",
    element: <AccountSearchController />
  }
];
